import { getAudioQualityThresholds } from "./constants";

export function toAudioQualityPayload(qualityResult) {
  if (!qualityResult) {
    return {
      audio_quality: {
        has_audio: null,
        has_speech: null,
        is_speech_clear: null,
      },
      audio_quality_raw: {
        thresholds: getAudioQualityThresholds(),
        amplitude: { rms_db: null, peak_db: null },
        speech_detection: null,
        speech_quality: null,
      },
    };
  }

  return {
    audio_quality: qualityResult.audio_quality,
    audio_quality_raw: qualityResult.audio_quality_raw ?? {
      thresholds: getAudioQualityThresholds(),
      amplitude: { rms_db: null, peak_db: null },
      speech_detection: null,
      speech_quality: null,
    },
  };
}
